import EditUserView from '../components/EditUserView';

export default EditUserView;
